import React from "react";
import MainBlock from "components/DesignSystem/LayoutBlocks/MainBlock";
import { useSelector } from "react-redux";
import ErrorCard from "Cards/ErrorCard";

const AnalyticsScreen = () => {
    const { settings } = useSelector((state) => ({
        settings: state.contentFlow?.settings,
    }));

    if (settings.settings?.plausibleUrl) {
        return (
            <MainBlock>
                <iframe
                    plausible-embed
                    src={settings.settings.plausibleUrl}
                    scrolling="yes"
                    frameborder="0"
                    loading="lazy"
                    style={{
                        width: "1px",
                        "min-width": "100%",
                        height: "1600px",
                    }}
                ></iframe>
                <div style={{ fontSize: "14px", paddingBottom: "14px" }}>
                    Stats powered by{" "}
                    <a
                        target="_blank"
                        style={{
                            color: "#4F46E5",
                            textDecoration: "underline",
                        }}
                        href="https://plausible.io"
                    >
                        Plausible Analytics
                    </a>
                </div>
                <script
                    async
                    src="https://analytics.getsnworks.com/js/embed.host.js"
                ></script>
            </MainBlock>
        );
    } else {
        return (
            <MainBlock>
                <ErrorCard title="Analytics not enabled">
                    Sorry, but the analytics feature is not enabled for this
                    site. To request access, please contact support.
                </ErrorCard>
            </MainBlock>
        );
    }
};

export default AnalyticsScreen;
